import { offchainTradingSharedStates } from './features/offchainTrading/offchainTrading.sharedStates';
import { teamSharedStates } from './features/teams/teams.sharedStates';
import { friendsSharedStates } from './features/friends/friends.sharedStates';
import { followingsSharedStates } from './features/followings/followings.sharedStates';

export const sharedStates = {
  teams: teamSharedStates,
  friends: friendsSharedStates,
  followings: followingsSharedStates,
  offchainTrading: offchainTradingSharedStates,
};

export default sharedStates;
